export default {
  auth: {
    linkSent: 'auth.linkSent',
    passwordReset: 'auth.passwordReset',
  },
};
